import { Card, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';

export const EmptyRowsRenderer = () => {
    const { t } = useTranslation();
    return (
        <Card
            sx={{
                textAlign: 'center',
                gridColumn: '1/-1',
                mt: 1
            }}
        >
            <Typography>{t('global.misc.this_table_is_empty')}</Typography>
        </Card>
    );
};
